module.exports = __webpack_public_path__ + "media/newstyle/images/hero-background-48b3db3cdeda911c179437430b8d1e33.png";